import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';
import FileInput from "../Utils/FileInput";
import Notification from "../Utils/Notification";
import FormButton from "../Utils/FormButton";
import {Editor} from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import {ContentState, convertToRaw, EditorState} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import {SUCCESS} from "../../utils/constants";
import Form from 'react-bootstrap/Form';

class PostForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            coverPhoto: null,
            coverPhotoLink: null,
            is_featured: false,
            title: '',
            body: '',
            type: 'blog',
            categories: [],
            blog_post_category_id: null,
            isLoading: false,
            postId: null,
            selectedType: { value: 'blog', label: 'Blog' },
            selectedCategory: {},
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleCoverPhotoChange = this.handleCoverPhotoChange.bind(this);
        this.editorOnChange = this.editorOnChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.uploadImageCallBack = this.uploadImageCallBack.bind(this);
    }

    async componentDidMount() {
        this.setState({ incorrect: false });
        let postId = this.props.match.params.id;

        // get categories
        const categoriesResponse = await axios.get(`/api/blog-post-categories`)
        let data = categoriesResponse.data.data;
        const mappedCategories = data.map(function (category) {
            return { value: category.id, label: category.name };
        })
        this.setState({ categories: mappedCategories });

        if(postId){
            this.setState({ postId })
            try{
                const response = await axios.get(`/api/blog/${postId}`)
                let data = response.data.data;

                const blocksFromHtml = htmlToDraft(data.body);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

                if(data.type == 'blog') {
                    this.setState({selectedType: { value: 'blog', label: 'Blog' }})
                } else {
                    this.setState({selectedType: { value: 'travelguide', label: 'Travel Guide' }})
                }

                const selectedCategory = mappedCategories.find((x) => x.value === data.blog_post_category_id)

                this.setState({
                    title: data.title,
                    body: data.body,
                    type: data.type,
                    is_featured: data.is_featured,
                    coverPhotoLink: data.cover,
                    blog_post_category_id: data.blog_post_category_id,
                    editorState: EditorState.createWithContent(contentState),
                    selectedCategory
                });
            } catch (e) {
                Notification({
                    data: e
                })
            } finally {
                this.setState({ loading: false });
            }
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleTypeChange({ value }) {
        if(value == 'blog') {
            this.setState({selectedType: { value: 'blog', label: 'Blog' }})
        } else {
            this.setState({selectedType: { value: 'travelguide', label: 'Travel Guide' }})
        }
        this.setState( {
            type: value,
        });
    }

    handleCategoryChange( category ) {
        this.setState( {
            selectedCategory: category,
            blog_post_category_id: category.value,
        });
    }

    handleCoverPhotoChange(e) {
        this.setState({ coverPhoto: e.target.files[0] });
    }

    async handleSubmit(event) {
        event.preventDefault();
        this.setState({ isLoading: true });
        try {
            const formData = new FormData();
            if(this.state.postId){
                if(this.state.coverPhoto){
                    formData.append('cover_photo', this.state.coverPhoto);
                    formData.append('title', this.state.title);
                    formData.append('body', this.state.body);
                    formData.append('type', this.state.type);
                    formData.append('is_featured', this.state.is_featured ? 1 : 0);
                    formData.append('blog_post_category_id', this.state.blog_post_category_id);
                    await axios.post(`/api/blog/${this.state.postId}`, formData)
                } else  {
                    let data = {};
                    data.title = this.state.title
                    data.body = this.state.body
                    data.type = this.state.type
                    data.is_featured = this.state.is_featured ? 1 : 0
                    data.blog_post_category_id = this.state.blog_post_category_id
                    data.cover_photo = this.state.coverPhoto
                    await axios.put(`/api/blog/${this.state.postId}/update`, data)
                }
                Notification({
                    type: SUCCESS,
                    message: 'Post edited successfully'
                })
            } else {
                formData.append('cover_photo', this.state.coverPhoto);
                formData.append('title', this.state.title);
                formData.append('body', this.state.body);
                formData.append('type', this.state.type);
                formData.append('is_featured', this.state.is_featured ? 1 : 0);
                formData.append('blog_post_category_id', this.state.blog_post_category_id);
                await axios.post('/api/blog', formData)
                this.setState({
                    coverPhoto: null,
                    title: '',
                    body: '',
                    type: 'blog',
                    blog_post_category_id: null,
                    editorState: EditorState.createEmpty(),
                })
                Notification({
                    type: SUCCESS,
                    message: 'Post created successfully'
                })
            }
        } catch (e) {
            Notification({
                data: e
            })
        } finally {
            this.setState({ isLoading: false });
        }
    }

    uploadImageCallBack(file) {
        return new Promise(
            (resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/upload-files/wysiwyg');
                const data = new FormData();
                data.append('file', file);
                xhr.send(data);
                xhr.addEventListener('load', () => {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response);
                });
                xhr.addEventListener('error', () => {
                    const error = JSON.parse(xhr.responseText);
                    reject(error);
                });
            }
        );
    }

    editorOnChange(editorState) {
        this.setState({
            body: draftToHtml(convertToRaw(editorState.getCurrentContent())),
            editorState
        })
    };

    render() {
        return (
            <div className="row justify-content-center">
                <div className="col-md-10">
                    {
                        this.state.postId ?
                        <h3 className="title">Edit Post</h3>
                            :
                        <h3 className="title">Add Post</h3>
                    }
                    <div className="card border-0">
                        <div className="card-body">
                            <form onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <div className="col-12">
                                        <FileInput
                                            label="Cover photo"
                                            onChange={this.handleCoverPhotoChange}
                                            name={this.state.coverPhoto ? this.state.coverPhoto.name : null}
                                        />
                                        {
                                            this.state.coverPhotoLink && <img
                                                src={`${s3AwsEndpoint}/${this.state.coverPhotoLink}`}
                                                alt=""
                                                width={240}
                                            />
                                        }
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Category</label>
                                        <Select
                                            id="blog_post_category_id"
                                            name="blog_post_category_id"
                                            required
                                            isDisabled={false}
                                            isLoading={false}
                                            isClearable={false}
                                            isRtl={false}
                                            isSearchable={false}
                                            options={this.state.categories}
                                            onChange={(e) => this.handleCategoryChange(e)}
                                            value={this.state.selectedCategory}
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <label htmlFor="is_featured">Featured post</label>
                                        <Form.Check
                                            type={'checkbox'}
                                            id="is_featured"
                                            checked={this.state.is_featured}
                                            onChange={() => this.setState({is_featured: !this.state.is_featured})}
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Post title"
                                            name="title"
                                            id="title"
                                            required
                                            autoComplete="off"
                                            value={this.state.title}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Body</label>
                                        <Editor
                                            editorState={this.state.editorState}
                                            onEditorStateChange={this.editorOnChange}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            toolbar={{
                                                inline: { inDropdown: true },
                                                list: { inDropdown: true },
                                                textAlign: { inDropdown: true },
                                                links: { inDropdown: true },
                                                history: { inDropdown: true },
                                                image: {
                                                    uploadCallback: this.uploadImageCallBack,
                                                    alt: { present: true, mandatory: true }
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Type</label>
                                        <Select
                                            id="type"
                                            name="type"
                                            required
                                            isDisabled={false}
                                            isLoading={false}
                                            isClearable={false}
                                            isRtl={false}
                                            isSearchable={false}
                                            options={[
                                                { value: 'blog', label: 'Blog' },
                                                { value: 'travelguide', label: 'Travel Guide' }
                                            ]}
                                            onChange={this.handleTypeChange}
                                            value={this.state.selectedType}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <div className="submit-btn mt-0">
                                            <FormButton
                                                isLoading={this.state.isLoading}
                                            />
                                            <Link to="/admin/dashboard/posts" className="btn btn-warning ml-1">
                                                Return
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PostForm);
